export default "__VITE_ASSET__ot$az5y3__"